var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loggedIn)?_c('v-layout',{attrs:{"row":""}},[_c('v-btn',{staticClass:"chat-btn",attrs:{"fixed":"","color":"#f11075"},on:{"click":function($event){return _vm.openChat()}}},[_c('p',{staticClass:"mb-0"},[_vm._v("Estou com dúvida")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }